import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { deleteCustomersAPI, getCustomersAPI, updateCustomersAPI } from "settings/account/components/Customers/request/request";
import { clearUserProfile } from "./userProfileSlice";

interface FetchCustomerArgs {
	token: string;
	tenantId: number;
  }

interface SelectionState {
  partnerId: number;
  partnerName: string;
  partnerDomain: string;
  tenantId: number;
  tenantName: string;
  tenantDomain: string;
  customerId?: string | null;
}

const initialState: SelectionState = {
  partnerId:   0,
  partnerName: "",
  partnerDomain: "", 
  tenantId:    0,
  tenantName:  "",
  tenantDomain: "",
  customerId: null,
};

const selectionSlice = createSlice({
  name: "selection",
  initialState,
  reducers: {
    setPartner(
      state,
      action: PayloadAction<{ id: number; name: string, domain: string }>
    ) {
      state.partnerId   = action.payload.id;
      state.partnerName = action.payload.name;
      state.partnerDomain = action.payload.domain;
      // reset tenant whenever they pick a new partner
      state.tenantId   = 0;
      state.tenantName = "";
      state.tenantDomain = "";   
    },
    setTenant(
      state,
      action: PayloadAction<{ id: number; name: string, domain: string, customerId?: string | null; }>
    ) {
      state.tenantId   = action.payload.id;
      state.tenantName = action.payload.name;
      state.tenantDomain = action.payload.domain;
      state.customerId =
      typeof action.payload.customerId === "undefined"
        ? state.customerId ?? null
        : action.payload.customerId;
    },
    clearSelection: () => initialState,
  },
  extraReducers: (builder) => {
    // when we clear the user profile, also clear selection
    builder
    .addCase(clearUserProfile, () => initialState);
  }
});


export const fetchCustomers = createAsyncThunk(
	"account/fetchCustomers",
    async ({ token, tenantId }: FetchCustomerArgs, thunkAPI) => {
      try {
      const response = await getCustomersAPI(token, tenantId);
      return response.data;
      } catch (error) {
      return thunkAPI.rejectWithValue(error);
      }
    }
);
export const updateCustomerName = createAsyncThunk(
  'customers/updateName',
  async ({ token, userId, name }: { token: string; userId: string; name: string }) => {
  try {
    const response = await updateCustomersAPI(token, userId, name)
    return response.data;
  } catch (error) {
    console.error(error)
  }
  }
);

export const deleteCustomer = createAsyncThunk(
  'customers/deleteCustomer',
  async ({ token, tenantId, userId }: { token: string; tenantId: number; userId: string }) => {
    try {
      console.log(tenantId, userId)
      const response = await deleteCustomersAPI(token, tenantId, userId)
      return response.data;
    } catch (error){
      console.error(error)
    }
  }
);

// Exportamos la acción y el reducer
export const { setPartner, setTenant, clearSelection } = selectionSlice.actions;
export default selectionSlice.reducer;